import React, { PropsWithChildren } from 'react';
import styles from './PopoverContent.module.css';
import clsx from 'clsx';

interface BzmPopoverProps {
  style?: any;
}

const PopoverContent = (props: PropsWithChildren<BzmPopoverProps>) => {
  return (
    <div className={clsx(styles.main)} style={props.style}>
      {props.children}
    </div>
  );
};

export const Header = (props: PropsWithChildren<any>) => {
  return <div className={clsx(styles.popoverHeader)}>{props.children}</div>;
};

export const Body = (props: PropsWithChildren<any>) => {
  return <div className={styles.popoverBody}>{props.children}</div>;
};

export const Footer = (props: PropsWithChildren<any>) => {
  return <div className={styles.popoverFooter}>{props.children}</div>;
};

PopoverContent.Header = Header;
PopoverContent.Body = Body;
PopoverContent.Footer = Footer;

export default PopoverContent;
